module.exports = __webpack_public_path__ + "static/media/2025_Greenland_Resources.3aaa8f89.pdf";